import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {Provider, useDispatch} from 'react-redux';
import 'bootstrap/dist/css/bootstrap.css';
import {Store} from './Redux/Store';
import reportWebVitals from './reportWebVitals';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// import 'bootstrap/dist/css/bootstrap.min.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    
      <GoogleOAuthProvider clientId="352039185363-uom7rftiiuric19q0ndi624t1cmdst1c.apps.googleusercontent.com">
          <Provider store={Store}>
            <App />
          </Provider>
      </GoogleOAuthProvider>
     
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
